// 3rd party
import { Component, Renderer2, ElementRef, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

// components
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';

// helpers
import { Helper } from 'app/shared/helpers/helper';

// models
import { ReportTemplate } from 'app/reports/shared/report-template.model';
import { ContactCustomer, ERoleActionWebview } from 'app/shared/models/contact-customer.model';

// services
import { ReportService } from 'app/reports/shared/report.service';
import { DialogsService } from 'app/shared/services/dialog/dialog.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit {

  checkedItems: number = 0;
  chkAll: boolean;
  columns: any[] = [
    { tag: 'c', name: 'Code', value: 'Translate.Code', isChecked: true },
    { tag: 't', name: 'Title', value: 'Translate.Title', isChecked: true },
    { tag: 'ct', name: 'Category', value: 'Translate.Category', isChecked: true },
    { tag: 'd', name: 'Description', value: 'Translate.Description', isChecked: true }
  ];
  currentPage: number = 1;
  data: any[];
  filter: string;
  hasReportViewPermission: boolean = false;
  isCheckingAll: boolean = false;
  isLoading: boolean = false;
  isSearching: boolean = false;
  orderBy: string = 'code';
  overallCount: number = 1;
  pageSize: number = 25;
  qtVisibleColumns: number = this.columns.filter(c => c.isChecked).length;
  search: string = '';
  selectedItems: any[] = [];
  sortOrder: string = 'asc';
  subscribe: Subscription;
  totalPages: number = 1;

  constructor(
    public dialog: DialogsService,
    private el: ElementRef,
    public mainLayout: LayoutMainComponent,
    private renderer2: Renderer2,
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.checkPermissions();
    this.refresh();
    this.checkColumnsPreferences();
  }

  checkAll(ev) {
    this.isCheckingAll = true;
    this.data.forEach((item) => {
      item.checked = ev.source.checked;
    });
    this.isCheckingAll = false;
    this.checkedItems = this.data.filter(item => item.checked).length;
  }

  checkColumn(event, str: string) {
    event.stopPropagation();
    let idx = this.columns.findIndex(c => c.tag === str);
    if (idx === -1) {
      return;
    }

    if (this.columns.filter(c => c.isChecked).length === 1 && this.columns[idx].isChecked) {
      return;
    }

    this.columns[idx].isChecked = !this.columns[idx].isChecked;
    this.qtVisibleColumns = this.columns.filter(c => c.isChecked).length;

    this.saveColumnsPreferences(this.columns);
  }

  checkColumnsPreferences() {
    if (!localStorage.getItem('webview.reportList.columns')) {
      this.saveColumnsPreferences(this.columns);
    }
    const savedColumns = JSON.parse(localStorage.getItem('webview.reportList.columns'));

    this.columns.forEach(c => c.isChecked = savedColumns.findIndex(sc => sc === c.tag) !== -1);
    this.qtVisibleColumns = this.columns.filter(c => c.isChecked).length;
  }

  checkPermissions() {
    const contact = JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer;
    this.hasReportViewPermission = ContactCustomer.hasPermission(ERoleActionWebview.ReportsView, contact.RoleWebView.ActionsPermissions);
  }

  enableSearch() {
    this.isSearching = !this.isSearching;
    this.search = '';
  }

  getReportCategory(category: number) {
    return this.reportService.getReportCategory(category);
  }

  isColumnChecked(str: string): boolean {
    let idx = this.columns.findIndex(c => c.tag === str);
    if (idx === -1) {
      return false;
    }

    return this.columns[idx].isChecked;
  }

  nextPage(e) {
    this.currentPage = e;
    this.refresh();
  }

  onSelectionChange() {
    if (!this.isCheckingAll) {

      if (this.data.filter(item => item.checked).length !== this.data.length && this.chkAll) {
        this.chkAll = false;
      }
      if (this.data.filter(item => item.checked).length === this.data.length && !this.chkAll) {
        this.chkAll = true;
      }

      this.selectedItems = this.data ? this.data.filter(d => d.checked) : [];
      this.checkedItems = this.data.filter(item => item.checked).length;
    }
  }

  previousPage(e) {
    this.currentPage = e;
    this.refresh();
  }

  refresh(search?: string, orderBy?: string, sortOrder?: string) {
    this.filter = '';
    this.selectedItems = this.data ? this.data.filter(d => d.checked) : [];
    if (search !== undefined) {
      this.search = search;
    }
    if (orderBy) {
      this.orderBy = orderBy;
    }
    if (sortOrder) {
      this.sortOrder = sortOrder;
    }
    this.filter += '"IsWebviewReport_=1"';
    const lstSpinner = this.el.nativeElement.querySelectorAll('mat-spinner');
    for (let x = 0; x < lstSpinner.length; x++) {
      this.renderer2.setStyle(lstSpinner[x], 'display', 'block');
    }
    let fields = '"' + this.columns.map(c => c.name).join('","') + '"';
    fields += ',"HasJsCode"';
    this.subscribe = this.reportService.get(null, this.search, this.orderBy, this.sortOrder, this.pageSize, this.currentPage, this.filter, fields).subscribe(data => {
      for (let x = 0; x < lstSpinner.length; x++) {
        this.renderer2.setStyle(lstSpinner[x], 'display', 'none');
      }
      this.data = data.json() as ReportTemplate[];

      if (this.selectedItems) {
        this.data.forEach(d => d.checked = this.selectedItems.find(s => s.Identifier === d.Identifier && s.checked) ? true : false);
      }
      this.checkedItems = this.data.filter(d => d.checked).length;
      this.overallCount = this.data.length > 0 ? this.data[0].OverallCount : 0;
      this.totalPages = Helper.getTotalPages(this.pageSize, this.overallCount);
    });
  }

  saveColumnsPreferences(columns: any[]) {
    localStorage.setItem('webview.reportList.columns', JSON.stringify(columns.filter(c => c.isChecked).map(c2 => c2.tag)));
  }

  searchData() {
    this.refresh(this.search);
  }

  setPageSize(n) {
    this.pageSize = n;
    this.currentPage = 1;
    this.refresh();
  }

  sortData(data) {
    this.refresh(undefined, data.orderBy, data.sortOrder);
  }

  viewForm() {
    let report = this.selectedItems[0] as ReportTemplate;
    if (!report.HasJsCode) {
      this.reportService.view(report.Identifier).subscribe(data => {
        const file = new Blob([data], { type: data.type });

        const fileUrl = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        a.setAttribute('target', '_blank');
        a.setAttribute('download', `${report.Title}`);
        document.body.appendChild(a);
        a.href = fileUrl;
        a.click();
      });
    } else {
      this.dialog.reportForm(report, this.mainLayout.app.currentContact.Customer.Id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-list/report-list.component.ts